import { TextFieldProps } from "@mui/material";
import { NO_NUMBER_ARROWS_MUI } from "../utils/global-styles";
import { FlexProps } from "./Flex";

import Input from "./Input";

type NumberInputProps = {
  label?: string;
  flexprops?: FlexProps;
  error?: string | boolean;
  required?: boolean;
  marginBottom?: string;
  min?: number;
  max?: number;
  textFieldProps?: Omit<TextFieldProps, "type">;
  blockedKeys?: string[];
  clearable?: boolean;
};
const DEFAULT_BLOCKED_KEYS = ["-", "+"];

const NumberInput = ({
  label,
  flexprops,
  error,
  required,
  marginBottom,
  min,
  max,
  textFieldProps,
  blockedKeys = DEFAULT_BLOCKED_KEYS,
  ...otherProps
}: NumberInputProps) => {
  return (
    <Input
      label={label}
      flexprops={flexprops}
      error={error}
      required={required}
      marginBottom={marginBottom}
      textFieldProps={{
        ...textFieldProps,
        type: "number",
        inputProps: { min: min ?? 0, max: max },
        sx: NO_NUMBER_ARROWS_MUI,
        onKeyDown: (e) => {
          if (blockedKeys.includes(e.key)) {
            e.preventDefault();
          }
          textFieldProps?.onKeyDown?.(e);
        },
        onChange: (e) => {
          const value = e.target.value;
          if (value && +value < 0) return;
          if (!!min && value && +value < min) e.target.value = String(min);
          if (!!max && value && +value > max) e.target.value = String(max);
          textFieldProps?.onChange?.(e);
        },
      }}
      {...otherProps}
    />
  );
};

export default NumberInput;
